import * as React from 'react';
import {useContext, useState} from "react";
import Container from '@mui/material/Container';
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Button from "@mui/material/Button/Button";
import Typography from "@mui/material/Typography/Typography";
import {useNavigate,useParams } from 'react-router-dom';
import Stack from "@mui/material/Stack/Stack";
import {AuthUserContext} from "../../providers/AuthProvider";
import moment from "moment";
import Box from "@mui/material/Box";
import Badge from "@mui/material/Badge/Badge";
import PostNotification from "../../helpers/post-notification";
import firebase from "../../firebase/firebase";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton, LinearProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Portal from "@mui/material/Portal";


export default function NotificationCenter(){
  const { user, profile} = useContext(AuthUserContext);
  let { projectId } = useParams();
  const navigator = useNavigate();
  const [notifications, setNotifications] = useState([])
  const [open, setOpen] = React.useState(false);
  const [currentContractId, setCurrentContractId] = React.useState(0)
  const [currentProjectId, setCurrentProjectId] = React.useState(0)
  const [loading, setLoading] = React.useState(true)
  const goToPayment = (x, y) => {
alert(x, y)
  }

  React.useEffect(() => {

    const notificationsRef = firebase.firestore().collection('notifications').orderBy('createdAt', 'desc');
    notificationsRef
      .where(profile.userType !== 'admin' ? 'uid':'showing',
        profile.userType !== 'admin' ? '==':'array-contains'
        , profile.userType !== 'admin' ? profile?.uid : profile.super ? 'super' : 'admin')
      .limit(30)
      .get()
      .then((data) => {
        if (data?.size > 0) {
          const list = []
          data.docs.forEach((d) => {
            list.push({id: d.id, ...d.data()})
          })
          setNotifications(list);
          setLoading(false);
        }
        if(notifications?.length===0){
          setLoading(false);
        }
      })

  }, [])

  if(loading) return(
    <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
  )
  if(!(notifications && notifications?.length>0))return(
    <>
               <div style={{width:"100%", display:"flex", justifyContent:"center", alignItems:"center", margin:"30vh auto"}}>
                <div>
                  <Typography variant="h3" color="primary"
                  >There are currently no notifications</Typography>
                  </div>
                  </div>
              </>
    )

  return (
    <React.Fragment>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}

      <Container maxWidth="fullWidth" sx={{backgroundColor: '#E3E8F0', paddingY: 5, }}>
        <Container maxWidth="lg" sx={{textAlign:'left' ,}}>
          <Typography variant={'h4'} sx={{paddingX: 2, textTransform:'uppercase'}} color={'primary'}>
            Notification center
          </Typography>
       

        </Container>
      </Container>


      <Container maxWidth="fullWidth" sx={{textAlign:'left', paddingY: 5, height: 'calc(100vh - 235px)',  overflowY: 'scroll'}}>
        <Container maxWidth="lg" sx={{textAlign:'left', paddingY: 5}}>

          <Stack
            direction="column"
            justifyContent="center"
            alignItems="stretch"

          > 

            {notifications.length > 0 && notifications.map((notification) => (

              <Box key={notification?.id} sx={{width: '100%', borderBottom: '1px solid #204488', cursor:'pointer',opacity: notification?.read ? .5 : 1 , '&:hover': {
                  backgroundColor: '#20448815',

                }}} onClick={() => {
                  if (!notification.read){
                    firebase.firestore().collection('notifications').doc(notification.id).update({read: true}).then()
                  }
                  if (notification?.link && notification?.link !== ''){
                    navigator(notification.link,
                      notification.state && JSON.parse(notification.state))
                  }
                  if (notification?.popup ){
                    setOpen(true);
                    setCurrentContractId(notification.contractId)
                    setCurrentProjectId(notification.projectId)
                  }

              }}>
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="stretch" p={2} spacing={1}>
                  <Typography variant={'caption'} color={'secondary'} align={'right'}>
                    {moment( notification.createdAt.seconds * 1000).format('ddd/MM/YYYY H:mm')}
                  </Typography>

                  <Typography variant={'h6'} color={'primary'} align={'left'}>
                    {!notification?.read && <Badge color={'primary'} variant="dot" sx={{mr: 2}}/>} {notification.title}
                  </Typography>

                  <Typography variant={'body1'} color={'secondary'} align={'left'}>
                    {notification.text}
                  </Typography>


                </Stack>


              </Box>

            ))}


          </Stack>

          <Dialog
                    open={open}
                    onClose={() => setOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='lg'
                    >
                    <DialogTitle id="alert-dialog-title" >
                      <Stack direction={'row'} spacing={2}>
                        <Typography variant={'h6'} sx={{flex:1, textAlign:'center'}} color={'primary'}>The next step</Typography>
                        <IconButton color={'primary'} onClick={() => setOpen(false)}>
                          <CloseIcon/>
                        </IconButton>
                      </Stack>
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description" >
                        <Typography variant={'body2'}>You will need to make the payment now in order to move forward</Typography>
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{paddingX: 3, paddingY: 2}}>
                      <Button  variant={'contained'} color={'warning'} sx={{paddingX: 3, backgroundColor: '#FD4A01', mx: 'auto'}} size={'small'} onClick={() => {
                        navigator(`/investor/payments/amount/${currentContractId}/${currentProjectId}`);
                      }}>
                        Make Payment
                      </Button>
                    </DialogActions>
                  </Dialog>

        </Container>
      </Container>


    </React.Fragment>
  );
}
